'use client';

import { useEffect } from 'react';
import { installVizLoaderBroker } from './vizLoaderBroker';

/**
 * Installs the window.vizLoader broker facade on every page, before the
 * visualizer exists. Analytics subscribers poll for window.vizLoader on the
 * first page they load — often a page with no visualizer — so the facade has to
 * be present there too, or the subscriber times out and never re-subscribes.
 * Mount once, high in the layout tree; it renders nothing.
 */
export function VizLoaderBrokerInit() {
  useEffect(() => {
    installVizLoaderBroker();
  }, []);

  return null;
}
